module.exports = __webpack_public_path__ + "static/media/4.61d0983e.jpg";